import { ReactElement } from 'react';
import Carousel from 'components/UI/Carousel';
import PhotoGalleryBlock from 'components/UI/PhotoGalleryBlock';
import { MAX_SCREEN_WIDTH } from 'lib/consts';
import { PhotoBlockProps } from './PhotoGallery';

interface PhotoGalleryCarouselProps {
  gallery: PhotoBlockProps[];
  slidesToShow?: number;
}

const IMAGES_PER_SLIDE = 3;
const maxImageWidth = Math.round(MAX_SCREEN_WIDTH / IMAGES_PER_SLIDE);

export default function PhotoGalleryCarousel({
  gallery,
  slidesToShow = 3,
}: PhotoGalleryCarouselProps): ReactElement {
  const carouselItems = gallery.map((image, index) => (
    <div className="px-2" key={index}>
      <PhotoGalleryBlock {...image} width={1} query={`w=${maxImageWidth}`} fullWidth />
    </div>
  ));

  return <Carousel title="" items={carouselItems} slidesToShow={slidesToShow} />;
}
